import React from 'react'
const JobProgress = (props) => {
  let {pass, fail, total} = props
  let passPercent = (Number(pass)/total)*100
  let failPercent = (Number(fail)/total)*100

  const totalStyle = {
    width: '100%',
    background: '#e0e0e0',
    height:'10px',
    marginTop: '10px',
    borderRadius: '5px',
    overflow: 'hidden',
    display: 'flex'
  }
  const passStyle = {
    width: `${passPercent}%`,
    background: '#4CAF50',
    height:'10px'
  };
  const failStyle = {
    width: `${failPercent}%`,
    background: '#FF5252',
    height:'10px'
  };

  return(
    <div style={totalStyle}>
      {pass ? (<div style={passStyle}></div>) : null}
      {fail ? (<div style={failStyle}></div>) : null}
    </div>
  )
}
export default JobProgress
